export const KakakSiagaNumber = "081119954075";

export const source = "hamburger_menu";

export const action = "call_me_back";
